<mat-form-field *ngIf="control" [appearance]="appearance" class="form-control-container">
  <mat-label>{{ getDisplayLabel() }}</mat-label>
  <mat-icon *ngIf="prefixIcon" matPrefix width="24px" height="24px">{{ prefixIcon }}</mat-icon>
  <mat-select
    [formControl]="control"
    *ngIf="isMultiselect && !isCheckboxDropdown"
    multiple
    [value]="defaultSelection"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option *ngFor="let option of options" [value]="option.value">{{ option.name | translate }}</mat-option>
  </mat-select>
  <mat-select
    #select
    [formControl]="control"
    *ngIf="isMultiselect && isCheckboxDropdown"
    multiple
    [value]="defaultSelection"
    (selectionChange)="onSelectionChange($event)"
  >
    <div class="select-all">
      <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{ standalone: true }" (change)="toggleAllSelection()">{{
        'INTL_SELECT_ALL' | translate
      }}</mat-checkbox>
    </div>
    <mat-option *ngFor="let option of options" [value]="option.value">{{ option.name | translate }}</mat-option>
  </mat-select>
  <mat-select
    [formControl]="control"
    *ngIf="!isMultiselect && !isCheckboxDropdown"
    [value]="defaultSelection"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option *ngIf="showEmptyValue" [value]="''"></mat-option>
    <ng-container *ngFor="let option of options; let index = index">
      <mat-option [ngClass]="{ 'highlight-option': option.value === 'cannot_find' }" [value]="option.value">{{
        option.name | translate
      }}</mat-option>
      <mat-divider *ngIf="separateFirstOption && index === 0"></mat-divider>
    </ng-container>
  </mat-select>
  <mat-hint>{{ hint | translate }}</mat-hint>
  <mat-error>
    <wai-form-error [formField]="control"></wai-form-error>
  </mat-error>

  <div matSuffix class="tooltip-container" *ngIf="tooltip">
    <mat-icon class="icon" aria-label="Tooltip" matTooltip="{{ tooltip }}" matTooltipClass="custom-tooltip"
      >error_outline</mat-icon
    >
    <!-- <div class="tooltip">{{ tooltip }}</div> -->
  </div>
</mat-form-field>
